import { useState } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

export default function ChargessummaryPage() {
	
	const [pageReady, setPageReady] = useState(true);
	 const [dateFrom, setDateFrom] = useState(null);
 const [dateTo, setDateTo] = useState(null);
 const [records, setRecords] = useState([]);
 const [loading, setLoading] = useState(false);
 const formatDate = (date) => {
     const year = date.getFullYear();
     const month = String(date.getMonth() + 1).padStart(2, "0");
     const day = String(date.getDate()).padStart(2, "0");
     return `${year}-${month}-${day}`;
 };
 const fetchData = async () => {
     if (!dateFrom || !dateTo) return;
     setLoading(true);
     try {
         const from = formatDate(dateFrom);
         const to = formatDate(dateTo);
         const exportUrl =
         dateFrom && dateTo
         ? `report/charges?DateFrom=${from}&DateTo=${to}`
         : "";
         const res = await fetch(
         `${process.env.REACT_APP_API_PATH}report/charges?DateFrom=${from}&DateTo=${to}`
         );
         const data = await res.json();
         setRecords(data.records || []);
         } catch (err) {
         console.error("Error fetching data:", err);
         } finally {
         setLoading(false);
     }
 };
 const exportChargesSummary = (format) => {
     const dF = formatDate(dateFrom);
     const dT = formatDate(dateTo);
     const url = `${process.env.REACT_APP_API_PATH}report/export-charges-summary?dateFrom=${dF}&dateTo=${dT}&export=${format}`;
     window.open(url, "_blank"); // triggers download
 };
 
const MailChargesSummary = async () => {
    if (!dateFrom || !dateTo) {
        alert('Please select both From Date and To Date');
        return;
    }
    
    const dF = formatDate(dateFrom);
    const dT = formatDate(dateTo);
    
    try {
        setLoading(true);
        const url = `${process.env.REACT_APP_API_PATH}report/mail-charges-summary?dateFrom=${dF}&dateTo=${dT}`;
        
        const response = await fetch(url, {
            method: 'POST', // Changed from POST to GET
            headers: {
                'Content-Type': 'application/json',
            },
        });
        
        if (response.ok) {
            const result = await response.json();
            alert(result.message || 'Email sent successfully!');
        } else {
            alert('Failed to send email. Status: ' + response.status);
        }
    } catch (error) {
        console.error('Error sending mail:', error);
        alert('Error sending email. Please try again.');
    } finally {
        setLoading(false);
    }
};



	return (
		<main id="ChargessummaryPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div className="col-12 comp-grid" >
                        <div className="">
                            <div className="p-4">
                                <h2 className="text-xl font-semibold mb-3">User Collection Report</h2>
                                <div className="flex gap-3 mb-4 flex-wrap">
                                    <div>
                                        <label className="block mb-1">From Date</label>
                                        <Calendar value={dateFrom} onChange={(e) => setDateFrom(e.value)} dateFormat="yy-mm-dd" />
                                    </div>
                                    <div>
                                        <label className="block mb-1">To Date</label>
                                        <Calendar value={dateTo} onChange={(e) => setDateTo(e.value)} dateFormat="yy-mm-dd" />
                                    </div>
                                    <div className="flex items-end gap-3">
                                        <Button label="Search" icon="pi pi-search" onClick={fetchData} loading={loading} />
                                    </div>
                                    <div className="flex items-end gap-3">
                                        <Button label="Export Excel" icon="pi pi-file-export" onClick={() => exportChargesSummary("excel")} />
                                    </div>
                                    <div className="flex items-end gap-3">
                                        <Button 
    label="Send Mail" 
    icon="pi pi-envelope" 
    onClick={() => MailChargesSummary()} 
    loading={loading}
/>

                                    </div>
                                </div>
                                <DataTable
                                    value={records}
                                    paginator
                                    rows={10}
                                    loading={loading}
                                    stripedRows
                                    responsiveLayout="scroll"
                                    >
                                    <Column field="userid" header="User ID" />
                                        <Column field="customername" header="Vendor Name" />
                                            <Column field="fullname" header="Account Name" />
                                                <Column field="account_number" header="Account No" />
                                                    <Column field="ifsc" header="IFSC" />
                                                        <Column field="collection" header="Debit Amount" />
                                                            <Column field="nos" header="Total Nos" />
                                                                <Column field="charges" header="Vendor Charges" />
                                                                    <Column field="paid_nos" header="Paid Nos" />
                                                                        <Column field="coll_amount" header="Collection Amount" />
                                                                            <Column field="paid" header="Vendor Payment" />
                                                                            </DataTable>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
		</main>
	);
}
